import React from 'react';
import {
  CHARGER_STATUS_ALARM,
  CHARGER_STATUS_ALERT,
  CHARGER_STATUS_AVAILABLE,
  CHARGER_STATUS_UNDEFINED,
  CHARGER_STATUS_UNKNOWN,
} from '../../constants/statuses';
import { StatusLabel } from '../../constants/CommonUsedDropdownsStatics';

const alarmLabel = (
  <div>
    <span className="label-partially_oos" />
    Alarm
  </div>
);
const alertLabel = (
  <div>
    <span className="label-alert" />
    Alert
  </div>
);
const availableLabel = (
  <div>
    <span className="label-available" />
    Available
  </div>
);

const RenderConnectorStates = (isStatic = false) => {
  const connectorStates = [
  {
    value: CHARGER_STATUS_ALARM.toUpperCase(),
    label: alarmLabel,
  },
  {
    value: CHARGER_STATUS_ALERT.toUpperCase(),
    label: alertLabel,
  },
  {
    value: CHARGER_STATUS_AVAILABLE.toUpperCase(),
    label: availableLabel,
  },
  {
    value: CHARGER_STATUS_UNDEFINED.toUpperCase(),
    label: '',
  },
];

if (isStatic) {
  connectorStates.push({
    value: undefined,
    label: '',
  })
};

return connectorStates.map(({ value, label }) => ({
  value,
  label: isStatic ? (<StatusLabel key={value} status={value === undefined ? CHARGER_STATUS_UNDEFINED.toUpperCase() : value} />) : label,
}));
}

export const AlertConnectorStates = (isStatic = false) => ([
  {
    value: CHARGER_STATUS_ALERT.toUpperCase(),
    label: alertLabel,
  },
  {
    value: CHARGER_STATUS_AVAILABLE.toUpperCase(),
    label: availableLabel,
  },
].map(({ value, label }) => ({
  value,
  label: isStatic ? (<StatusLabel key={value} status={value} />) : label,
})));

export default RenderConnectorStates;
